import http from "../../core/services/http.service";

export default {
  getData() {
    return http.get('/api/v1/docs/');
  },
};
